import React, { useState } from 'react';
import './BulkUpdateModal.css';
import { Modal, Button } from 'react-bootstrap';
import { DROP_REASONS } from '../../constants/DropOffSummary';

const DropOverrideBulkUpdateModal = ({
  show,
  onHide,
  onConfirm,
  checkedItems,
  loading = false,
}) => {
  const [status, setStatus] = useState('Complete');
  const [reason, setReason] = useState(DROP_REASONS[status][0].value);

  useState(() => {
    setReason(DROP_REASONS[status][0].value);
  }, [status]);

  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
    >
      <Modal.Header closeButton onHide={loading ? undefined : onHide}>
        <Modal.Title id="contained-modal-title-vcenter" className="modalTitle">
          Bulk Drop Status Update
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="bodyText">
          Please, choose Drop Status and Reason that you want to apply for{' '}
          <b>{checkedItems}</b> items that you checked
        </p>
        <div className="modalRow">
          <div className="dropdownWrapper">
            <div className="title">Drop Status</div>
            <select onChange={(e) => setStatus(e.target.value)} value={status}>
              <option value="Complete">Complete</option>
              <option value="Not Delivering">Not Delivering</option>
            </select>
          </div>
          <div className="dropdownWrapper">
            <div className="title">Drop Reason</div>
            <select onChange={(e) => setReason(e.target.value)} value={reason}>
              {DROP_REASONS[status].map(({ value, text }) => (
                <option value={value} key={value}>
                  {text}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} disabled={loading} className="footerButton">
          Close
        </Button>
        <Button
          onClick={() => onConfirm(status, reason)}
          className="btn-success footerButton"
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Confirm Override'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DropOverrideBulkUpdateModal;
